﻿/**
 * footer Module
 * @module footerModule
 * @namespace components.footerModule
 */
'use strict';

angular.module('components.footerModule', [])
.controller('footerController', require('./footerController.js'))
.directive('ebFooter', require('./ebFooterDirective.js'));


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/footer/index.js
// module id = 50
// module chunks = 0